 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"b793c08dc7b509ac15cebcd1004dd9de24ba1f0d","2":"bd738d178474a56466c3deb43237f18a769c6d78","3":"5404b1e99f51178678bf74b7bdef68d20ae3c203","4":"e0bc13af0980e4bcd7adaad0eab7fba3be379dce","5":"30f7af81fd50f6f27e680458a45610406abb6d10","6":"33ce6ab0","7":"4c355f13","8":"c05b8182","9":"component---src-pages-layout-js","10":"b7379c5878cf0bc15f6307d5d520fc93b771184e","11":"66d25248ebf4a22e59d0c75782ea62a17ce0df4a","12":"c7b2e9691ea16af45323a573fef157833c10127a","13":"73364092ccffa8f8d2ecc27131881debde7f3890","14":"f60216f65af1d19c77940037e0f5a44253b8b987","16":"11e8d57d","18":"4b80be75","19":"5cf42e9e","20":"962beaf7","22":"component---src-pages-404-js","23":"component---src-pages-banner-js","24":"component---src-pages-build-better-js","25":"component---src-pages-classic-home-js","26":"component---src-pages-community-videos-collection-tsx","27":"component---src-pages-community-videos-index-tsx","28":"component---src-pages-community-videos-watch-tsx","29":"component---src-pages-docs-template-js","30":"component---src-pages-integration-builder-index-tsx","31":"component---src-pages-integration-builder-sections-build-tsx","32":"component---src-pages-integration-builder-sections-card-generator-tsx","33":"component---src-pages-integration-builder-sections-code-tsx","34":"component---src-pages-integration-builder-sections-configure-tsx","35":"component---src-pages-integration-builder-sections-demo-tsx","36":"component---src-pages-integration-builder-sections-help-modal-tsx","37":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","38":"component---src-pages-integration-builder-sections-preview-tsx","39":"component---src-pages-integration-builder-sections-take-live-tsx","40":"component---src-pages-internal-js","41":"component---src-pages-signup-js","42":"component---src-pages-signupauto-js","43":"component---src-pages-support-js","44":"component---src-pages-test-card-manager-index-tsx","45":"component---src-pages-thankyou-js","46":"component---src-pages-unsubscribe-js","47":"component---src-templates-template-layout-js","48":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"74c4c9978d371684a888","2":"aa9e601f37c29e89b546","3":"c5362b51daeee0c0185c","4":"c20d6a037dbc6217640f","5":"555e05f998ec8f2c993f","6":"3a747f3b13918f3bb0bc","7":"5be4a33420af14b8e4ba","8":"84cb6a49d80763e6f029","9":"c759d6378907477f4c0b","10":"32043a829f98c6421979","11":"1207679c72788920d1b2","12":"b8e2746036456cb57cbb","13":"9f5f7bd1f7214d7025bc","14":"e904ea5b7728e16a3432","16":"42bfa4c2df87579a8340","18":"a1049628b23d952c0ede","19":"94b7b2c5e28d493008e2","20":"b072c47956294641c3b1","22":"3a8f903c39cc05a7e77e","23":"6bde2702665356e9cbb8","24":"e5d6f02dbc4d5a73b39c","25":"857183bb26c92e2cf0e6","26":"8f611407da0f74107fdb","27":"911855948791d98e84ff","28":"80a23c6adf00fd31adff","29":"f99a0358f9a3559abc84","30":"69fdb35bcaed0dc4ddd1","31":"3c95e67c156fd128a98b","32":"2c835ce8ad166da9677c","33":"b700734a28251fb07429","34":"dfbfb43f1282302c1e8b","35":"afda48b77bb795b0c28d","36":"53c9d343d817658bc0fe","37":"51d2fabd6bb5d031dfb0","38":"41c2d2bbb10d46b3061f","39":"adba3f1e0ba6df52ecfa","40":"4840591d27e4d552476a","41":"6a769103c666df1cb6d9","42":"ced7ae0038ece733106a","43":"d4f166f6e74b72210a61","44":"8ce2827f8e93a6e6f157","45":"f243daf675574422668b","46":"3e26aaf38117bcfb3840","47":"6bd2ac07fef528f41361","48":"2c754599468426af3b9d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"b793c08dc7b509ac15cebcd1004dd9de24ba1f0d","2":"bd738d178474a56466c3deb43237f18a769c6d78","3":"5404b1e99f51178678bf74b7bdef68d20ae3c203","4":"e0bc13af0980e4bcd7adaad0eab7fba3be379dce","5":"30f7af81fd50f6f27e680458a45610406abb6d10","6":"33ce6ab0","7":"4c355f13","8":"c05b8182","9":"component---src-pages-layout-js","10":"b7379c5878cf0bc15f6307d5d520fc93b771184e","11":"66d25248ebf4a22e59d0c75782ea62a17ce0df4a","12":"c7b2e9691ea16af45323a573fef157833c10127a","13":"73364092ccffa8f8d2ecc27131881debde7f3890","14":"f60216f65af1d19c77940037e0f5a44253b8b987","16":"11e8d57d","18":"4b80be75","19":"5cf42e9e","20":"962beaf7","22":"component---src-pages-404-js","23":"component---src-pages-banner-js","24":"component---src-pages-build-better-js","25":"component---src-pages-classic-home-js","26":"component---src-pages-community-videos-collection-tsx","27":"component---src-pages-community-videos-index-tsx","28":"component---src-pages-community-videos-watch-tsx","29":"component---src-pages-docs-template-js","30":"component---src-pages-integration-builder-index-tsx","31":"component---src-pages-integration-builder-sections-build-tsx","32":"component---src-pages-integration-builder-sections-card-generator-tsx","33":"component---src-pages-integration-builder-sections-code-tsx","34":"component---src-pages-integration-builder-sections-configure-tsx","35":"component---src-pages-integration-builder-sections-demo-tsx","36":"component---src-pages-integration-builder-sections-help-modal-tsx","37":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","38":"component---src-pages-integration-builder-sections-preview-tsx","39":"component---src-pages-integration-builder-sections-take-live-tsx","40":"component---src-pages-internal-js","41":"component---src-pages-signup-js","42":"component---src-pages-signupauto-js","43":"component---src-pages-support-js","44":"component---src-pages-test-card-manager-index-tsx","45":"component---src-pages-thankyou-js","46":"component---src-pages-unsubscribe-js","47":"component---src-templates-template-layout-js","48":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"0296528256674e9acf11","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/migrationv1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
